<div class="uw-dialog-header">
  <h1 class="uw-dialog-heading">{{ "content.edit_faq" | translate }}</h1>

  <button [attr.aria-label]="'aria.close' | translate" cdkFocusInitial mat-icon-button mat-dialog-close>
    <mat-icon>
      close
    </mat-icon>
  </button>
</div>

<div class="uw-dialog-content" [formGroup]="form">

  <div class="uw-field">
    <label for="question" class="uw-label">
      {{ "content.question" | translate }}
    </label>
    <input id="question" type="text" class="uw-input" formControlName="question">
    @if (!form.pristine && form.get('question')?.errors?.required) {
      <span class="uw-error-message">{{ "errors.required" | translate }}</span>
    }
  </div>

  <div class="uw-field">
    <label class="uw-label">
      {{ "content.answer" | translate }}
    </label>
    <uw-html-editor formControlName="answer"></uw-html-editor>
    @if (!form.pristine && form.get('answer')?.errors?.required) {
      <span class="uw-error-message">{{ "errors.required" | translate }}</span>
    }
  </div>

</div>

<div class="uw-dialog-footer">
  <div class="uw-actions">

    <button class="uw-stroked-button" mat-dialog-close>
      {{ "common.cancel" | translate }}
    </button>

    <button class='uw-default-button' [disabled]="form.pristine || !form.valid" (click)="handleSave(form.value)">
      {{ "common.save" | translate }}
    </button>

  </div>
</div>


